var map = {
	"./HealthSense.png": "o08X",
	"./Heights-and-Hills-Logo.png": "dN0u",
	"./ccs-logo.png": "OXIG",
	"./logo.png": "QaFb",
	"./salerno-logo-by.png": "xO2G",
	"./salerno-logo.png": "2Hsz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+/UT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu nonrecursive \.png$
// module id = +/UT
// module chunks = 1